import { get, patch } from "@/application/api";
import { ShowPromise } from "@/application/api/getPaginated";
import {
  CompanyDetailsRequestResource,
  CompanyDetailsShowResource,
} from "@/modules/tenantAdmin/companyDetails/types";
import { AxiosPromise } from "axios";

export const show = (
  config?: object,
): ShowPromise<CompanyDetailsShowResource> => {
  return get("company-details", config);
};

export const update = (
  data: Partial<CompanyDetailsRequestResource>,
): AxiosPromise<void> => {
  return patch("company-details", data);
};
